import {
  addDomainUrl,
  cloneDomainUrl,
  getDomainBackupUrl,
  getDomainDetailById,
  getDomainList,
  getDomainListUrl,
  updateDomainById,
  validateImportedDomainUrl,
  reactivateDomainUrl,
  validateRequestUrl,
} from "./constants";
import base from "../middlewares/interceptors";
import { IGetDomainProp } from "../types/resource";
import { getConfig } from "../config/runtimeConfig";

const config = {
  headers: {
    // 'Authorization': 'Bearer my-token',
    "Content-Type": "application/json",
  },
};

export const getDomains = async () => {
  try {
    const response = await base.get(getDomainListUrl, config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getDomainDetail = async ({ currentDomainId }: any) => {
  try {
    const response = await base.get(
      `${getDomainDetailById}/${currentDomainId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addDomain = async (reqBody: any) => {
  try {
    const response = await base.post(addDomainUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateDomain = async ({ currentDomainId, payload }: any) => {
  try {
    const comment = payload?.domain?.comment?.trim();
    const requestUrl = comment
      ? `${updateDomainById}/${currentDomainId}?comment=${encodeURIComponent(
          comment
        )}`
      : `${updateDomainById}/${currentDomainId}`;
    const response = await base.put(requestUrl, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteDomain = async (currentDomainId: number) => {
  try {
    const response = await base.delete(
      `${updateDomainById}/${currentDomainId}`
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};
export const cloneDomain = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${cloneDomainUrl}/${reqBody.domain_id}`,
      reqBody
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getDomainPaginatedList = async ({
  page,
  pSize,
  searchTerm,
  isActive = "true",
  signal,
}: IGetDomainProp) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;

    // Build base URL with pagination parameters
    let requestUrl = `${getDomainList}?page=${pageN}&size=${pageS}`;

    // Conditionally add is_active parameter only when not "all"
    // When isActive is "all" or empty, omit the parameter to fetch all domains
    if (isActive && isActive !== "all") {
      requestUrl += `&is_active=${isActive}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      requestUrl += `&domain_name=${encodeURIComponent(searchTerm.trim())}`;
    }

    const response = await base.get(requestUrl, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getDomainBackup = async ({ domainId, page, pSize }: any) => {
  try {
    const pageN = page == null ? getConfig("REACT_APP_DEFAULT_PAGE", "1") : page;
    const pageS =
      pSize == null ? getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") : pSize;

    let requestUrl;
    if (domainId && domainId !== 0) {
      requestUrl = `${getDomainBackupUrl}?domain_backup_filter_ids=${domainId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ValidateImportedDomain = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${validateImportedDomainUrl}/${reqBody?.entity_description?.id}`,
      reqBody
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Reactivate domain
 * @param domainId - The ID of the domain to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateDomain = async (domainId: string | number) => {
  try {
    const response = await base.put(
      `${reactivateDomainUrl}/${domainId}/reactivate`
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating domain:", error);
    throw error;
  }
};

export const validateConfigRequest = async (reqBody: any) => {
  try {
    const response = await base.post(validateRequestUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error("Error validating request:", error);
    return Promise.reject(error);
  }
};
